// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Footer__Wrapper_28Xd9","Title":"Footer__Title_2Jpow","Link":"Footer__Link_1d3Bg"};